import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Panel, Message } from 'rsuite';
import { setToken, isTokenValid } from '../../utils/auth';

export default function LoginPage() {
  const navigate = useNavigate();
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isTokenValid()) {
      navigate('/dashboard/main');
    }
  }, [navigate]);

  async function handleSubmit() {
    setError('');
    setLoading(true);
    try {
      const body = new URLSearchParams();
      body.append('username', login);
      body.append('password', password);

      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });

      if (!res.ok) {
        const data = await res.json();
        setError(data.detail || 'Ошибка авторизации');
        return;
      }

      const data = await res.json();
      setToken(data.access_token);
      navigate('/dashboard/main');
    } catch {
      setError('Ошибка соединения с сервером');
    } finally {
      setLoading(false);
    }
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter') handleSubmit();
  }

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      background: '#f5f5f5',
    }}>
      <Panel header="Вход" bordered style={{ width: 360, background: '#fff' }}>
        {error && (
          <Message type="error" style={{ marginBottom: 16 }}>
            {error}
          </Message>
        )}
        <Form fluid onKeyDown={handleKeyDown}>
          <Form.Group>
            <Form.ControlLabel>Логин</Form.ControlLabel>
            <Form.Control
              name="login"
              value={login}
              onChange={setLogin}
              autoComplete="username"
            />
          </Form.Group>
          <Form.Group>
            <Form.ControlLabel>Пароль</Form.ControlLabel>
            <Form.Control
              name="password"
              type="password"
              value={password}
              onChange={setPassword}
              autoComplete="current-password"
            />
          </Form.Group>
          <Button
            appearance="primary"
            block
            onClick={handleSubmit}
            loading={loading}
          >
            Войти
          </Button>
        </Form>
      </Panel>
    </div>
  );
}
